module.exports = {
    chatStarted: 'Chat iniciado el {date}',
    chatJoin: '*** {name} se ha unido al chat ***',
    chatClosed: '*** El chat ha sido cerrado ***'
};


// WEBPACK FOOTER //
// ./conversationTranscript/defaultLabels/es.js